import React from 'react';
import { Box, Typography, IconButton, Button, Paper, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

// Styled components
const Overlay = styled(Box)(({ }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay
  backdropFilter: 'blur(0px)', // Blur effect
  zIndex: 999, // Behind the popup but above other content
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: 660,
  borderRadius: theme.shape.borderRadius * 2,
  overflow: 'hidden',
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000, // Above the overlay
}));

const HeaderBox = styled(Box)(({ }) => ({
  padding: '20px 24px',
  borderBottom: '1px solid #e6e6e6',
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'left',
}));

const FooterBox = styled(Box)(({ }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '20px 24px',
  borderTop: '1px solid #e6e6e6',
}));

const TitleTypography = styled(Typography)(({ }) => ({
  fontSize: '24px',
  lineHeight: '32px',
  fontWeight: 600,
  fontFamily: 'Volte Semibold',
}));

const StyledIconButton = styled(IconButton)(({ }) => ({
  width: 24,
  height: 24,
  color: '#202020',
}));

const StyledButton = styled(Button)(({ }) => ({
  borderRadius: 32,
  padding: '8px 24px',
  textTransform: 'none',
  fontWeight: 600,
  lineHeight: '24px',
}));

const CloseButton = styled(StyledButton)(({ }) => ({
  border: '1px solid #E6E6E6',
  color: '#202020',
  fontFamily: 'Volte Medium',
}));

// SessionExpirationPopup component
const SessionExpirationPopup = ({ sessionExpired, onLogin, onClose }) => {
  // Don't render if sessionExpired is false
  if (!sessionExpired) return null;

  const handleBackdropClick = (e) => {
    // Close the popup if clicked outside the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Background blur overlay */}
      <Backdrop
        open={sessionExpired} // Open based on sessionExpired prop
        onClick={handleBackdropClick} // Close when clicked outside the popup
        sx={{ color: '#fff', zIndex: 1300 }}
      >
        <Overlay onClick={handleBackdropClick} />

        {/* Popup content */}
        <StyledPaper elevation={3}>
          {/* Header */}
          <HeaderBox>
            <Box display="flex" justifyContent="space-between" alignItems="center" textAlign="left">
              <Box>
                <TitleTypography>Session Expired</TitleTypography>
              </Box>
              <StyledIconButton onClick={onClose}>
                <CloseIcon />
              </StyledIconButton>
            </Box>
          </HeaderBox>

          {/* Content */}
          <ContentBox>
            <Typography variant="body2" color="textSecondary">
              Your session has expired. Please log in again.
            </Typography>
          </ContentBox>

          {/* Footer */}
          <FooterBox>
            <CloseButton variant="outlined" onClick={onLogin}>
              Login
            </CloseButton>
          </FooterBox>
        </StyledPaper>
      </Backdrop>
    </>
  );
};

export default SessionExpirationPopup;
